import React from 'react';
import moment from 'moment';

export default function DoctorSkeleton({ work_date, start_at, isLoading }) {
  const timeStr = start_at ? moment(start_at).format('HH:mm') : '—';
  const dateStr = moment(work_date).format('DD.MM.YYYY');

  return (
    <div className="streaming-records-item streaming-records-item--skeleton">
      <div className="streaming-records-item__information">
        <div className="streaming-records-item__user">
          <div className="streaming-records-item__user-icon skeleton-circle" />
          <div className="streaming-records-item__user-about">
            <div className="skeleton-line skeleton-line--md" style={{ marginBottom: 8 }} />
            <div className="skeleton-line skeleton-line--sm" />
          </div>
        </div>
        <div className="streaming-records-item__address">
          {isLoading ? (
            <ul className="streaming-records-item__address-list">
              <li className="streaming-records-item__address-list-item">
                <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 6 }} />
                <div className="skeleton-line skeleton-line--md" />
              </li>
              <li className="streaming-records-item__address-list-item">
                <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 6 }} />
                <div className="skeleton-line skeleton-line--md" />
              </li>
            </ul>
          ) : (
            <div className="streaming-records-item__address-list-item-description">
              Помилка завантаження
            </div>
          )}
        </div>
      </div>
      <div className="streaming-records-item__period">
        <div className="streaming-records-item__period-date">
          <strong>{timeStr}</strong>
          {dateStr}
        </div>
      </div>
    </div>
  );
}
